<template >
      <Layout>
         <PageHeader :title="title" :items="items" />
            
               <div class="row">
                  <div class="col-12">
                     <div class="card">
                        <div class="card-body">
                                
                           <!----- top button area starts---->
                           <div class="row mb-3">
                              <div class="col-12">

                                 <a href="#" @click.prevent="$router.go(-1)" class="btn btn-primary float-end"><i  class='bx bx-chevrons-left'></i> Back</a>

                              </div>
                           </div>
                           <!----- top button area ends---->                  

                           <!---- Details starts -------->
                           <div class="row" >
                              <div class="col-lg-6">
                                 <div header-class="bg-transparent border-light" class="border border-light">
                                    <h4  class="font-size-16 bg-light  border border-top-0 border-start-0 border-end-0 py-2 px-3 mb-3" style="color:black"> Booking Details</h4>                             

                                 <div class="table-responsive ">
                                    <table class="table mb-0 w-100">
                                       <tbody >
                                          
                                                        <tr>
                                                            <th>Test Type</th>
                                                            <th>:</th>
                                                            <td><span v-if="booking.collecting_type === 1">
                                                                     Lab
                                                                </span>
                                                                <span v-else>
                                                                    Home
                                                                </span>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <th>Booking Date</th>
                                                            <th>:</th>
                                                            <td>
                                                                {{ booking.booking_date|formatDate }}                                                             
                                                            </td> 
                                                        </tr>

                                                        <tr>
                                                            <th>Booking Slot</th>
                                                            <th>:</th>
                                                            <td>
                                                                {{ booking.start_time|formatTime }} - {{ booking.end_time|formatTime }}                                                             
                                                            </td> 
                                                        </tr>
                                                        <tr v-if="booking.schedule_name">
                                                            <th>Schedule Name</th>
                                                            <th>:</th>
                                                            <td>
                                                                {{ booking.schedule_name }}                                                              
                                                            </td> 
                                                        </tr>

                                                        <tr>
                                                            <th>Booked for</th>
                                                            <th>:</th>
                                                            <td>
                                                                <span v-if="booking.member_id">{{ booking.member_name }}</span>
                                                                <span v-else>{{ booking.patient_name }}</span>                                                              
                                                            </td> 
                                                        </tr>
                                                        <tr>
                                                            <th>Status</th>
                                                            <th>:</th>
                                                            <td><span v-if="booking.status === 1">
                                                                Completed
                                                                </span>
                                                                <span v-else-if="booking.status === 2">
                                                                Pending
                                                                </span>
                                                                <span v-else-if="booking.status === 3">
                                                                    No Show
                                                                </span>
                                                                <span v-else-if="booking.status === 4">
                                                                    Cancelled
                                                                </span>
                                                            </td>
                                                        </tr>
                                                        <tr v-if="booking.status === 4">
                                                            <th>Cancelled By</th>
                                                            <th>:</th>
                                                            <td>
                                                                <span v-if="booking.cancel_by == 1">clinic</span>
                                                                <span v-else-if="booking.cancel_by == 3">Patient</span>   
                                                                <span v-else-if="booking.cancel_by == 5">Lab</span>                                                           
                                                            </td> 
                                                        </tr>
                                                        <tr v-if="booking.status === 4">
                                                            <th>Cancelled On</th>
                                                            <th>:</th>
                                                            <td>
                                                                {{ booking.cancelled_at|formatDateTime  }}                                                          
                                                            </td> 
                                                        </tr>

                                                        <tr>
                                                            <th>Created On</th>
                                                            <th>:</th>
                                                            <td>
                                                                {{ booking.converted_created_at  }}    
                                                            </td>
                                                        </tr>

                                                        
                                                        </tbody>  
                                            
                                                    </table>


                                                    
                                            </div>
                                        </div>
                                        <div header-class="bg-transparent border-light" class="border border-light" >

                            <b-card header-class="bg-transparent border-light" class="border border-light" v-if="booking.prescriptions.length>0">
                                <h4 class="font-size-18 bg-light border border-top-0 border-start-0 border-end-0 p-3 mb-3">Prescriptions</h4>
                                <ul class="list-unstyled p-0 m-0">
                                 
                                    <li class="mb-3" v-for="(prescription, index) in booking.prescriptions" :key="index">
                                 <div v-if="prescription.prescription_type==2"> 
                                       <a :href="$image_url + prescription.prescription_url" target="_blank" class="font-size-22"><p class="text-primary"><i class="fas fa-file-alt me-3"></i></p></a>  
                                       </div>
                                       <div  v-if="prescription.prescription_type==1"  v-bind:style="{ 'background-image': 'url(' + prescription.prescription_url + ')' }">

                                          <img  :src="$image_url + prescription.prescription_url" alt
                                             class="avatar-sm me-4" @click="viewPrescription(prescription)">
                                       </div>  
                              </li>
                                </ul>
                            </b-card>


                        <div header-class="bg-transparent border-light" class="border border-light" v-if="tests && tests.length > 0">
                                            <h4  class="font-size-16 border-top-0 border-start-0 border-end-0 py-2 px-3 mb-3" style="color:black"> </h4>                             
                                            
                                            <div class="table-responsive ">
                                                    <table class="table mb-0 w-100">
                                                        <thead class="table-light">
                                                        <tr>
                                                            <th>Test Name</th>
                                                            <th>Test Price</th>              
                                                        </tr>
                                                    </thead>
                                                        <tbody  v-for="(test) in tests" :key="test.id" >
                                            
                                                        <tr>
                                                            <td>
                                                                {{ test.test_name }}
                                                            </td>
                                                            <td>
                                                                {{ test.price }}
                                                            </td>
                                                         
                                                        </tr>
                                                       
                                                    </tbody>  
                                            
                                                </table>
                                            </div>
                        </div>
                        <div header-class="bg-transparent border-light" class="border border-light" v-if="order.location">
                                    <h4  class="font-size-16 bg-light  border border-top-0 border-start-0 border-end-0 py-2 px-3 mb-3" style="color:black"> Address Details</h4>                             

                                 <div class="table-responsive ">
                                    <table class="table mb-0 w-100">
                                       <tbody >
                                          
                                                        <tr>
                                                            <th>Name</th>
                                                            <th>:</th>
                                                            <td>
                                                                {{ order.location.name }}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <th>Mobile</th>
                                                            <th>:</th>
                                                            <td>
                                                                {{ order.location.country_code }}{{ order.location.phone }}                                                            
                                                            </td> 
                                                        </tr>

                                                        <tr>
                                                            <th>Email</th>
                                                            <th>:</th>
                                                            <td>
                                                                {{ order.location.email }}                                                             
                                                            </td> 
                                                      </tr>
                                                        <tr>
                                                            <th>House No</th>
                                                            <th>:</th>
                                                            <td>
                                                                {{ order.location.house_no }}                                                             
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <th>Address</th>
                                                            <th>:</th>
                                                            <td>
                                                                {{ order.location.address }}                                                             
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <th>Pincode</th>
                                                            <th>:</th>
                                                            <td>
                                                                {{ order.location.pincode }}                                                             
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <th>Location</th>
                                                            <th>:</th>
                                                            <td>
                                                                {{ order.location.map_location }}                                                             
                                                            </td>
                                                        </tr>
                                                        
                                                        </tbody>  
                                            
                                                    </table>


                                                    
                                            </div>
                                        </div>              
                                        </div>
                                    </div>
                                 
                                    <div class="col-lg-6 col-md-6">
                                        

                                        <div header-class="bg-transparent border-light" class="border border-light">
                                            <h4 class="font-size-16 bg-light  border border-top-0 border-start-0 border-end-0 py-2 px-3 mb-3" style="color:black">User Details</h4>                             

                                                <div class="table-responsive ">
                                                    
                                                    <table class="table mb-0 w-100">
                                                        <tbody >
                                                            <tr>
                                                                <th>User ID</th>
                                                                <th>:</th>
                                                                <td>#{{ booking.patient_id }}</td>
                                                            </tr>                                       
                                                            
                                                            <tr>
                                                                <th>User Name</th>
                                                                <th>:</th>
                                                                <td>
                                                                    {{ booking.patient_name }}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <th>Mobile</th>
                                                                <th>:</th>
                                                                <td>
                                                                    {{ booking.country_code }} {{ booking.mobile }}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <th>Email</th>
                                                                <th>:</th>
                                                                <td>
                                                                    {{ booking.email }}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <th>Gender</th>
                                                                <th>:</th>
                                                                <td><span v-if="booking.gender === 1">
                                                                    Male
                                                                    </span>
                                                                    <span v-else-if="booking.gender === 2">
                                                                    Female
                                                                    </span>
                                                                    <span v-else>
                                                                        Others
                                                                    </span>
                                                                </td>
                                                                
                                                            </tr>
                                                        </tbody>  
                                            
                                                    </table>   

                                                    
                                            </div>
                                        </div> 

                                        <div>
                                            <div header-class="bg-transparent border-light" class="border border-light mt-3 card" v-if="booking.status === 1">  
                                                <h4 class="font-size-16 bg-light  border border-top-0 border-start-0 border-end-0 py-2 px-3 mb-3">Reports</h4>
                                                <div class="row me-2">  
                                                    <div class="col-12 ">
                                                        <div class="col-12">
                                                            <b-button variant="primary" class="btn btn-primary float-end mb-3" v-b-modal.result-modal >Upload Result</b-button>
                                                        
                                                        </div>   

                                                        <div class="col-12">
                                                            <table class="table table-bordered ms-2 mb-3">
                                                                <tbody >
                                                                    <tr>
                                                                        <th>Report ID</th>
                                                                        <th>Options</th>
                                                                    </tr>                                       
                                                                    
                                                                    <tr v-for="(result) in results" :key="result.id">
                                                                        <td>#{{ booking.patient_name }}{{ result.id }}</td>
                                                                        <td>
                                                                            <b-button variant="info" class="btn  me-1 btn-sm" @click = "downloadResult(result)">Download</b-button>
                                                                        </td>
                                                                        
                                                                    </tr>
                                                                </tbody>  
                                                    
                                                            </table>   
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                        <b-card header-class="bg-transparent border-light" class="border border-light" v-if="order.location">
                           <h4 class="font-size-18 bg-light border border-top-0 border-start-0 border-end-0 p-3 mb-3">Location</h4>
                           <b-row>                          

                              <b-col md="12" lg="12">
                                 <p>{{order.location.map_location}}</p>                              
                              </b-col> 
                              <b-col  md="12">
                                 <GmapMap v-if="order.location"
                                 :center="center"
                                 :zoom="18"
                                 map-style-id="roadmap"
                                 :options="mapOptions"
                                 style="width: 100%; height: 300px"
                                 ref="mapRef">                              
                                    <GmapMarker
                                       :position="marker.position"
                                       :clickable="false"
                                       :draggable="false"                                    
                                    />
                              </GmapMap>        
                              </b-col>

                           </b-row>
                        </b-card>
                                        </div>

                                    
                                    </div>
                                    
                                    
                                </div>
                                <!---- Details ends -------->

                                <b-modal ref="result-modal" id="result-modal" :title="modal_title" hide-footer @hidden="clearForm()">
                                    <b-form @submit.prevent="uploadResult()" >                        
                                        <div class="row"> 
                                            <b-form-group class="col-lg-12" v-if="!edit">

                                                <div class="col-md-12 form-group">
                                                    <label class="control-label">Test report <span class="text-danger">*</span></label>
                                                    <input class="form-control" type="file" ref="fileInput"  @change="handleFileUpload" v-bind:class="{ 'is-invalid': Boolean(errors.file) }"/>
                                                    <div v-for="(val, index) in errors.file" :key="index" class="invalid-feedback">
                                                        <p class="mb-0">{{ val }}</p>
                                                    </div>
                                                    
                                                </div>
                                                
                                            </b-form-group>

                                            <b-col md="12" class="mt-3">
                                                <b-button type="submit" class="me-3" variant="primary">Upload</b-button>
                                                <b-button class="" variant="light" @click="hideModal('result-modal')">Close</b-button>
                                            </b-col>
                                        </div>                       
                                    </b-form>
                                </b-modal>
<!---- modal starts ---->
<b-modal ref="view-prescription-modal" id="view-prescription-modal" title="View Prescription" hide-footer>
                     <b-row>
                        
                        <b-col md="12" class="form-group">
                           <div class="prescription-images">
                              <ul>
                                 <li>
                                    <a :href="$image_url + this.prescription_url" target="_blank">
                                       <div class="file-pdf2" v-if="this.prescription_type==2"> 
                                          <img class="" src="@/assets/images/pdf.png" alt="PDF" >
                                       </div>
                                       <div class="file-img2" v-if="this.prescription_type==1"  v-bind:style="{ 'background-image': 'url(' + $image_url + this.prescription_url + ')' }">
                                          
                                       </div>   
                                    </a>
                                 </li>
                              </ul>
                           </div>
                        </b-col>
                        
                        <b-col md="12">
                           <b-button class="" variant="primary" @click="hideModal('view-prescription-modal')">Close</b-button>
                        </b-col>
                     </b-row>
                  </b-modal>
                  <!---- modal ends ----->
                            </div>
                        </div>
                    </div>
                </div>
    </Layout>
</template >

<script>
import Layout from '../../layouts/main'
import PageHeader from '@/components/page-header'
import appConfig from "@/app.config";

export default {
   page: {
      title: "Booking Details",
      meta: [
         {
            name: "description",
            content: appConfig.description,
         },
      ],
   },

   components: { Layout, PageHeader },

   data() {
		return {
			title: "Booking Details",
			items: [
            {
               text: "Labs",
               href: "/labs",
            },  

            {
               text: "Bookings",
               href: "/labs/bookings",
            }, 
				{
               text: "Details",
					active: true,
				},        
			],
				
			pagination: {},
			edit: false,
				
            patient: {},
            booking: {},
            // tests: {},
            results: {},
            location: {},

			keyword: "",
			showsearch: false,
			listing_length: 10,
			type: 0,
			token: "",
			errors: {},
			activate: false,
         deactivate: false,
         prescription_type:'',
         prescription_url:'',

			modal_title: "Upload Report",
         button_title: "Save",  

         active_page_url: null,
         order: {
               location: 'Kochi, Kerala, India',
            },
            
            marker: { position: { lat: 9.9312328, lng: 76.26730409999999 } },
            center: { lat: 9.9312328, lng: 76.26730409999999 },

            mapOptions: {
               disableDefaultUI: true,
            },   
            tests: [], 
		};
	},


   mounted() {
		
   },

   created() {
        this.fetchBooking();
   },

   methods: {

    fetchBooking(){

        let url = "clinic/lab/booking/details?booking_id=" + this.$route.params.id;
            this.getToken();
            this.loading = true;
            this.$axios
            .get(url, { headers: { Authorization: "Bearer " + this.token } })
            .then((res) => {
               var responseData = res.data.data;
               console.log(responseData);

               // Use responseData.lab and responseData.bookings_count
            //    this.patient = responseData.patient;
               this.booking = responseData.booking;
               this.tests = responseData.tests;
               this.order.location = responseData.booking.address;
               this.results = responseData.results;

                if(this.order.location){
                    this.marker.position.lat = parseFloat(this.order.location.latitude);
                    this.marker.position.lng = parseFloat(this.order.location.longitude);

                    this.center.lat = parseFloat(this.order.location.latitude);
                    this.center.lng = parseFloat(this.order.location.longitude);
                }  

            })
            .catch((error) => {

               if (error.response) {
                  if (error.response.data.message) {

                     if (typeof error.response.data.message === 'object') {
                        console.log(error.response.status);
                     } else {
                        this.$swal("", error.response.data.message, "error");
                     }
                  }
                  else {
                     this.$swal("", "Something went wrong", "error");
                  }
               } else {
                  this.$swal("", "Something went wrong", "error");
               }

            })
            .finally(() => (this.loading = false));




    },

    clearForm() {
            this.errors = {};
            this.file_upload = "";
    },



    uploadResult(){

    this.getToken();

    const config = {
        headers: {

            "Content-Type": "multipart/form-data",
            "Accept": "application/json",
            "Authorization": "Bearer " + this.token,
        },
    };

    let url = "clinic/lab/booking/result";
    let formData = new FormData();
    formData.append("booking_id", this.$route.params.id);
    formData.append('file', this.file_upload);
    this.$axios
        .post(url, formData, config)
        .then((response) => {
            if (response.data.status) {
                this.$swal("", response.data.message, "success");
            } else {
                this.$swal("", response.data.message, "error");
            }
            this.$router.push({ name: 'labs.bookings.details' });
            this.hideModal('result-modal');
            this.clearForm();
            this.fetchBooking();
        })
        .catch((error) => {
            if (error.response) {
                if (error.response.data.message) {
                    this.errors = error.response.data.message;
                    //console.log(this.errors);
                } else {
                    this.$swal("", "Something went wrong", "error");
                }
            } else {
                this.$swal("", "Something went wrong", "error");
            }
        })
        .finally(() => (this.loading = false));

    },


    downloadResult(result){

			let url = "clinic/lab/booking/result-download?result_id=" + result.id;
            this.getToken();
            this.loading = true;
            this.$axios
               .get(url, {
                     headers: { Authorization: "Bearer " + this.token },
                     responseType: "blob" 
               })
               .then((res) => {
                     const blob = new Blob([res.data], { type: "application/pdf" });
                     const url = window.URL.createObjectURL(blob);
                     const link = document.createElement("a");
                     link.href = url;
                     link.download = "Patient_report.pdf"; 
                     link.click();
                     window.URL.revokeObjectURL(url);
               })
               .catch((error) => {
                     console.error("Error downloading PDF file:", error);
                     this.$swal("", "Failed to download PDF file", "error");
               })
               .finally(() => (this.loading = false));





    },

    handleFileUpload(){

        this.file_upload = this.$refs.fileInput.files[0];

    },

    getToken() {
            if (localStorage.getItem('medicino_clinic')) {
               var medicino_clinic =  JSON.parse(localStorage.getItem('medicino_clinic'));
               if(medicino_clinic.token) {
                  this.token = medicino_clinic.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
	}, 

    showModal(modal) {
        this.$refs[modal].show();
    },

    hideModal(modal) {
        this.$refs[modal].hide();
    },
    viewPrescription (prescription) {
            this.prescription_type = prescription.prescription_type;
            this.prescription_url = prescription.prescription_url;
            console.log(this.prescription_url);
            this.showModal('view-prescription-modal');
         }, 


    
   }

}

    

</script>